import * as React from 'react';
import { ITranslationsCollection, translate } from 'elc-service';
import { COLOR_FAMILY } from '../../constants/ColorFamilyOptions';
import { observer } from 'mobx-react';
import { IMapping } from '../../../exported/product-cta/ProductCTA';

export interface IColorFamilyLabels {
    name: string;
    translations?: ITranslationsCollection;
}

export const ColorFamilyLabel = translate([
    'violetColorFamilyLabel',
    'pinkColorFamilyLabel',
    'redColorFamilyLabel',
    'nudeColorFamilyLabel',
    'fairColorFamilyLabel',
    'veryFairColorFamilyLabel',
    'mediumColorFamilyLabel',
    'deepColorFamilyLabel',
    'berryColorFamily',
    'brownColorFamily',
    'beigeColorFamily',
    'darkColorFamily',
    'greenColorFamily',
    'greyColorFamily',
    'lightColorFamily',
    'mediumFairColorFamily',
    'moderateColorFamily',
    'orangeColorFamily',
    'blueColorFamily',
    'purpleColorFamily',
    'otherColorFamily',
    'yellowColorFamily'
])(
    observer((props: IColorFamilyLabels) => {
        const { name } = props;

        const {
            violetColorFamilyLabel,
            pinkColorFamilyLabel,
            redColorFamilyLabel,
            nudeColorFamilyLabel,
            fairColorFamilyLabel,
            veryFairColorFamilyLabel,
            mediumColorFamilyLabel,
            mediumFairColorFamily,
            deepColorFamilyLabel,
            berryColorFamily,
            brownColorFamily,
            beigeColorFamily,
            darkColorFamily,
            greenColorFamily,
            greyColorFamily,
            lightColorFamily,
            moderateColorFamily,
            orangeColorFamily,
            blueColorFamily,
            purpleColorFamily,
            otherColorFamily,
            yellowColorFamily
        } = props.translations as ITranslationsCollection;

        const colorFamilyLabels: IMapping = {
            [COLOR_FAMILY.BERRY]: berryColorFamily,
            [COLOR_FAMILY.BLUE]: blueColorFamily,
            [COLOR_FAMILY.BROWN]: brownColorFamily,
            [COLOR_FAMILY.BEIGE]: beigeColorFamily,
            [COLOR_FAMILY.DARK]: darkColorFamily,
            [COLOR_FAMILY.DEEP]: deepColorFamilyLabel,
            [COLOR_FAMILY.FAIR]: fairColorFamilyLabel,
            [COLOR_FAMILY.GREEN]: greenColorFamily,
            [COLOR_FAMILY.GREY]: greyColorFamily,
            [COLOR_FAMILY.LIGHT]: lightColorFamily,
            [COLOR_FAMILY.MEDIUM]: mediumColorFamilyLabel,
            [COLOR_FAMILY.MEDIUM_FAIR]: mediumFairColorFamily,
            [COLOR_FAMILY.MODERATE]: moderateColorFamily,
            [COLOR_FAMILY.NUDE]: nudeColorFamilyLabel,
            [COLOR_FAMILY.ORANGE]: orangeColorFamily,
            [COLOR_FAMILY.OTHER]: otherColorFamily,
            [COLOR_FAMILY.PINK]: pinkColorFamilyLabel,
            [COLOR_FAMILY.PURPLE]: purpleColorFamily,
            [COLOR_FAMILY.RED]: redColorFamilyLabel,
            [COLOR_FAMILY.VERY_FAIR]: veryFairColorFamilyLabel,
            [COLOR_FAMILY.VIOLET]: violetColorFamilyLabel,
            [COLOR_FAMILY.YELLOW]: yellowColorFamily
        };

        return <span>{colorFamilyLabels[name] || name}</span>;
    })
);
